import { fromJS } from 'immutable';

import * as actions from './AppActions';

export const ProdigyApp = {
  Appraisal: 'Appraisal',
  AppraisalDemo: 'AppraisalDemo',
  AppraisalAdmin: 'AppraisalAdmin',
  Assessment: 'Assessment',
  CI: 'CI',
  Events: 'Events',
  EquityFinder: 'EquityFinder',
  Litigation: 'Litigation',
  Maintenance: 'Maintenance',
  MRA: 'MRA',
  Sketch: 'Sketch',
};

const initialState = fromJS({
  activeApp: null,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_ACTIVE_APP: {
      return state.set('activeApp', action.payload);
    }
    default: {
      return state;
    }
  }
};

export const getActiveApp = state => state.getIn(['app', 'app', 'activeApp']);
